import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { getAboutBanner } from 'Store/Banners/selectors';
import BannerAbout from 'Components/BannerAbout/BannerAbout';

interface IPropsInternal {
  aboutContent: Julius.Content.Banner;
}

class BannerNewsAndSocialMediaContainer extends React.PureComponent<IPropsInternal> {
  render() {
    return (
      <BannerAbout
        aboutContent={ this.props.aboutContent }
        localPathAbout='/information/om'
        localPathContact='/information/kontakt'
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    aboutContent: getAboutBanner(state),
  };
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, null),
)(BannerNewsAndSocialMediaContainer);


// WEBPACK FOOTER //
// ./src/components/BannerAbout/BannerAboutContainer.tsx